/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import useGeniatech from '../../../../../../../hooks/shared/geniatech/useGeniatech';
import GeniatechContext from '../../../../../../../context/GeniatechContext';
import { TOWER_URL } from '../api/TowerUrl';

const TowerProvider = ({ children }) => {
  const { data, loading, pages, search, searchData, onChange, searchStatus, reset, fetched } = useGeniatech(
    {
      action: 'towers',
      offset: '0',
      limit: '100',
      network_id: 'tz-xwf',
    },
    `${TOWER_URL}`,
  );
  return (
    <GeniatechContext.Provider
      value={{
        data,
        loading,
        search,
        searchData,
        pages,
        onChange,
        searchStatus,
        reset,
        fetched,
      }}
    >
      {children}
    </GeniatechContext.Provider>
  );
};
export default TowerProvider;
